<template>
  <div class="js">
    <div class="head-list">
      <div v-for="(item, index) in headList" :key="index">
        <el-tooltip placement="bottom" v-if="item.tooltip">
          <div slot="content">{{item.tooltip}}</div>
          <div style="cursor: pointer;">
            <div class="num" style="display: flex;align-items: center;">{{item.value}}<img src='@/assets/images/common/icon-gth.png'/></div>
            <div class="text">{{item.name}}{{item.unit}}</div>
          </div>
        </el-tooltip>
        <div v-else>
          <div class="num">{{item.value}}</div>
          <div class="text">{{item.name}}{{item.unit}}</div>
        </div>
      </div>
    </div>
    <div class="search-list">
      <div class='filter-item'>
        <div class="filter-text">结算周期</div>
        <div class="time">
          <el-date-picker
            v-model="filter.settlementDate"
            type="daterange"
            range-separator="至"
            format="yyyy-MM-dd"
            @change="getList"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </div>
      <div class='filter-item'>
        <div class="filter-text">所属平台</div>
        <el-select
            class="el-input-dark mr-16px"
            v-model="filter.sysSource"
            placeholder="选择平台"
            @change="getList"
            clearable
            filterable>
            <el-option v-for="(item, index) in sysSourceList" :key="index" :value="item" :label="item" />
        </el-select>
      </div>
      <div class='filter-item'>
        <div class="filter-text">所属店铺</div>
        <el-select
            class="el-input-dark mr-16px"
            v-model="filter.sellerName"
            placeholder="选择店铺"
            @change="getList"
            clearable
            filterable>
            <el-option v-for="(item, index) in shopList" :key="index" :value="item" :label="item" />
        </el-select>
      </div>
    </div>
    <div class="content">
      <div class="top"><div class="icon"></div>结算记录</div>
      <div>
        <div class='ux-tabs tabs' style="margin:0 40px;
          width:calc(100% - 80px);margin-top:16px;min-height:100px">
          <div class="ux-filter-records filter-records">
            <div class='content-list' style="height:auto">
              <el-table
                class="table ux-dark-el-table"
                :data="tableData"
                empty-text="暂无数据"
                element-loading-spinner="el-icon-loading">
               <el-table-column label="序号" type="index" width="80" align="center" >
               </el-table-column>
               <el-table-column label="结算周期" show-overflow-tooltip align="center" >
                    <template slot-scope="scope">
                      <div class="text">{{ scope.row.accountsStarttime || '--' }} -{{ scope.row.accountsEndtime ||'--' }}</div>
                    </template>
               </el-table-column>
                  <el-table-column v-for="(props, i) in tableHeader" :label='props.label' align="center" :key="i" show-overflow-tooltip>
                    <template #header>
                      <el-tooltip :content="props.tooltip" placement="top" v-if="props.tooltip">
                        <div class="headertext" style="display: flex;align-items: center;">{{props.label}}<img src='@/assets/images/common/icon-gth.png'/></div>
                      </el-tooltip>
                      <div v-else>
                        <div class="headertext">{{props.label}}</div>
                      </div>
                    </template>
                    <template slot-scope="scope">
                      <div class="text">{{ scope.row[props.prop] }}</div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
            <div class='pages'>
              <span>共 {{ page.total }} 条数据</span>
              <el-pagination
                class="ux-dark-el-pagination"
                small
                background
                layout="prev, pager, next"
                :current-page="page.current"
                :page-size="page.size"
                :total="page.total"
                @current-change="currentChange"
              />
              <pagination @currentChange="currentChange" @sizeChange="sizeChange"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import common from '@/utils/common'
// import languageObj from '@/utils/lan.json'
import pagination from '@/components/main/bigData/home/compontents/pagination.vue'
import apiPath from '@config/api.json'
import { Loading } from 'element-ui'
const {mapState, mapMutations} = require('vuex')
export default {
  components: { pagination },
  props: ['info'],
  data () {
    return {
      tableHeader: [
        // {
        //   type: 'index',
        //   label: '序号'
        // },
        // {
        //   prop: 'accountsStarttime',
        //   label: '结算周期'
        // },
        {
          prop: 'platform',
          label: '所属平台'
        },
        {
          prop: 'accountName',
          label: '所属店铺'
        },
        {
          prop: 'balance',
          label: '期初余额（元）',
          tooltip: '从上一周期结转的金额'
        },
        {
          prop: 'productPrice',
          label: '商品价格总计（元）'
        },
        {
          prop: 'sales',
          label: '销售额（元）',
          tooltip: '通过已配送订单收取的金额等于商品价格、运费、礼品包装费和税费之和减去任何促销优惠金额'
        },
        {
          prop: 'refundAmount',
          label: '退款（元）'
        },
        {
          prop: 'expend',
          label: '支出（元）',
          tooltip: '在亚马逊账户级别或交易级别产生的费用及广告等服务的收费'
        },
        {
          prop: 'reserveDebit',
          label: '预留金额（元）',
          tooltip: '预留金额，用于确保您有足够的资金处理任何索赔或信用卡拒付'
        },
        {
          prop: 'deposit',
          label: '存款总计（元）',
          tooltip: '期初余额和销售额之和减去退款、支出、贷款还款额以及任何未转账金额的净金额'
        }
      ],
      filter: {
        sellerName: '全部店铺',
        settlementDate: '',
        sysSource: '全部平台'
      },
      summary: {},
      tableData: [],
      headList: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      shopList: []
    }
  },

  computed: {
    ...mapState({
      searchDate: (state) => {
        return state.home.searchDate
      },
      // shopList: (state) => {
      //   return state.home.shopList
      // },
      sysSourceList: (state) => {
        return state.home.sysSourceList
      }
    })
  },

  watch: {
    searchDate: function (n) {
      this.init()
    }
  },

  created () {
    // this.setLanguageMsg(this.lan)
  },

  mounted () {
    this.init()
  },

  methods: {
    ...mapMutations({}),
    init () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.js.getEnterpriseAccountSummary}${this.info.customerNo}`
      }).then(res => {
        if (res.data && res.data) {
          this.summary = res.data
          let that = this
          this.headList = [
            {
              name: '销售总额',
              value: that.summary.transaction || '0',
              unit: '（元）'
            }, {
              name: '结算总额',
              value: that.summary.settledTotal || '0',
              unit: '（元）'
            }, {
              name: '已结算金额',
              value: that.summary.settledAmount || '0',
              unit: '（元）'
            }, {
              name: '支出总额',
              value: that.summary.totalExpend || '0',
              unit: '（元）',
              tooltip: '在亚马逊账户级别或交易级别产生的费用及广告等服务的收费'
            }, {
              name: '费用占比',
              value: that.summary.expenseRatio || '0%',
              unit: '',
              tooltip: '支出总额/销售总额'
            }, {
              name: '结算商品数',
              value: that.summary.productNum || '0',
              unit: '（个）'
            }, {
              name: '结算笔数',
              value: that.summary.settledCount || '0',
              unit: '（笔）'
            }
          ]
        }
      })
      this.getList()
      this.getShopList()
    },
    getShopList () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.dict.getShopList}/${this.info.customerNo}`
      }).then(res => {
        res.data.unshift('全部店铺')
        this.shopList = res.data || []
      })
    },
    getList () {
      let settlementDate = []
      if (this.filter.settlementDate) settlementDate = this.filter.settlementDate
      const loadTips = Loading.service()
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.js.getEnterpriseSettlement}`,
        data: {
          'customerNo': this.info.customerNo,
          'pageNum': this.page.current,
          'pageSize': this.page.size,
          'searchDate': this.searchDate,
          'accountsStarttime': settlementDate[1],
          'accountsEndtime': settlementDate[0],
          'platform': this.filter.sysSource === '全部平台' ? '' : this.filter.sysSource,
          'accountName': this.filter.sellerName === '全部店铺' ? '' : this.filter.sellerName
        }
      }).then(res => {
        loadTips.close()
        const dataInfo = res.data || {}
        this.page.total = dataInfo.total
        this.tableData = dataInfo.records
      })
    },
    currentChange (e) {
      this.page.current = e
      this.getList()
    },
    sizeChange (e) {
      this.page.current = 1
      this.page.size = e
      this.getList()
    }
  }
}
</script>

<style lang='scss' scoped>
  .js{
    .search-list{
      display: flex;
      align-items: center;
      border: 1px solid rgb(71,166,234);
      border-radius: 6px;
      padding: 16px 20px 16px 20px;
      margin:16px 32px 16px 32px;
      .filter-item{
        display: flex;
        align-items: center;
        margin-right: 48px;
        .filter-text{
          margin-right: 16px;
          font-size: 16px;
        }
      }
    }
    .head-list{
      display: flex;
      margin-top: 30px;
      margin-bottom: 24px;
      justify-content: space-between;
      padding: 0 150px;
      color:#fff;
      font-size:24px;
      .num{
        color: rgb(71,166,234);
        font-size:24px;
        line-height: 40px;
        text-align: center;
        img{
          width: 30px;
          height: 30px;
          margin-left:4px;
        }
      }
      .text{
        font-size:18px;
        line-height: 24px;
      }
    }
    .content{
      border: 1px solid rgb(71,166,234);
      border-radius: 6px;
      padding: 16px 20px 32px 20px;
      margin:0 32px 16px 32px;
      .top{
        display: flex;
        font-size:18px;
        .icon{
          width: 20px;
          height: 20px;
          border-radius: 4px;
          background: rgb(71,166,234);
          margin-right:16px;
        }
      }
      .title{
        text-align: center;
        font-size:18px;
      }
    }
    .headertext{
      display: flex;
      justify-content: space-around;
      img{
        width: 30px;
        height: 30px;
      }
    }
  }
</style>
<style lang='scss'>
  .time{
    .el-range-input {
      background: transparent !important;
    }
    .el-range-separator{
      color: #fff !important;
    }
  }
  .el-tooltip__popper{
    width: 100px !important;
    text-align: center;
  }
  .el-year-table td.today .cell{
    color: #606266;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/search/compontents/js.vue